// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1jB1a","label":"SetPasswdForm_label__3m0we"};